import React from "react";

import "../../../../styles/css/App.css";

import { Switch, Route, useRouteMatch, withRouter } from "react-router-dom";
import TablePlaces from "../table-places";
import PlaceForm from "../form/place-form";
import { PlaceCategories, Place } from '../../../../plas/map/places/models';
import alerter from "../../../alerts/alerter.jsx";


function Accommodations({ history }) {
  
  let { path, url } = useRouteMatch();

  const onOpen = (event, rowData) => {
    if (rowData !== undefined) {
      history.push(`${url}/` + rowData.id);
    }
  }

  const onClose = () => {
    history.goBack()
  }

  const onSave = () => {
    onClose()
    alerter.showSuccess("Se guardaron los cambios del alojamiento.")
  }

  const generatePlace = () => {
    let place = new Place();
    place.makeAlwaysOpen()
    return place;
  }

  const options = {
    schedule: 'hidden',
    contact: {
      delivery: 'hidden'
    }
  }

  return (
    <div>
      <Switch>
        <Route exact path={path}>
          <TablePlaces
            open={onOpen}
            rootCategory={PlaceCategories.ACCOMMODATION}
            title={"Alojamientos"}
            initialPlace={ generatePlace() }
            options={options}
            deleteMessage="¿Está seguro de que desea borrar este alojamiento?"
            noDataMessage="No hay alojamientos para mostrar"/>
        </Route>
        <Route exact path={`${path}/:businessId`}
          render={ (props) => 
            <PlaceForm 
              options={options}
              rootCategory={PlaceCategories.ACCOMMODATION} 
              placeId={props.match.params.businessId}
              onSave={onSave}
              onCancel={onClose}/>
          }
        />
      </Switch>
    </div>
  );

}

export default withRouter(Accommodations);
